import { ReportLang } from "../reportLang";
import { ayurmaEn, AyurmaStrings } from "./en";
import { ayurmaRu } from "./ru";
import { ayurmaZh } from "./zh";

// Record<ReportLang, ...> is the exhaustiveness check: adding a language to
// REPORT_LANGS breaks this file until a dictionary exists for it.
const DICTIONARIES: Record<ReportLang, AyurmaStrings> = {
  en: ayurmaEn,
  ru: ayurmaRu,
  zh: ayurmaZh,
};

export const getAyurmaStrings = (lang: ReportLang): AyurmaStrings =>
  DICTIONARIES[lang];

export type { AyurmaStrings };
